// src/components/Chat/NoiseSummaryBar.tsx
// Kartu ringkasan noise — modern, integrated

import React from "react";
import { NoiseSummary } from "../../types/chatTypes";

interface NoiseSummaryBarProps {
  summary: NoiseSummary;
}

const NoiseSummaryBar: React.FC<NoiseSummaryBarProps> = ({ summary }) => {
  if (summary.total === 0) return null;

  const items = [
    { label: "Tenang", count: summary.tenang, color: "#4CAF50", bg: "rgba(76,175,80,0.12)" },
    { label: "Sedang", count: summary.sedang, color: "#FF9800", bg: "rgba(255,152,0,0.12)" },
    { label: "Berisik", count: summary.berisik, color: "#F44336", bg: "rgba(244,67,54,0.12)" },
    { label: "Sgt Berisik", count: summary.sangatBerisik, color: "#9C27B0", bg: "rgba(156,39,176,0.12)" },
  ];

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 6,
      padding: "8px 12px",
      background: "rgba(37,41,65,0.6)",
      borderBottom: "1px solid rgba(74,144,226,0.15)", flexShrink: 0,
    }}>
      {items.map((item) => (
        <div key={item.label} style={{
          flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
          padding: "5px 2px", borderRadius: 8, background: item.bg,
          gap: 1,
        }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: item.color, lineHeight: 1.2 }}>
            {item.count}
          </span>
          <span style={{
            fontSize: 8, color: item.color, fontWeight: 600,
            textTransform: "uppercase", letterSpacing: 0.3, lineHeight: 1.2, opacity: 0.85,
          }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default NoiseSummaryBar;
